module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan2-1-fd4ff8e48d29deab713148e7c6720ddf.webp";